import detectMobileDevice from 'is-mobile';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

import ButtonBase from '../ButtonBase';

export default function SideTab({
  title,
  onClick,
  align = 'left',
  textFontFamily,
  background,
  color,
  padding,
  isSidetabOnInit,
  sidetabParameters,
  ...props
}) {
  const ref = React.useRef(null);
  const [sideAlignSize, setSideAlignSize] = React.useState(0);
  const isMobile = detectMobileDevice();

  const handleClick = (e, ...args) => {
    if (onClick) {
      onClick(e, ...args);
    }
  };

  React.useEffect(() => {
    if (ref.current && !sideAlignSize) {
      setSideAlignSize(ref.current.scrollHeight / 2);
    }
  }, [sideAlignSize]);

  return (
    <Root
      ref={ref}
      fontFamily={textFontFamily}
      padding={padding}
      background={background}
      color={color}
      align={align}
      sideAlignSize={sideAlignSize}
      isSidetabOnInit={isSidetabOnInit}
      sidetabParameters={sidetabParameters}
      isMobile={isMobile}
      onClick={handleClick}
      {...props}
    >
      {title}
    </Root>
  );
}

SideTab.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  align: PropTypes.oneOf(['right', 'left']),
  background: PropTypes.string.isRequired,
  padding: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  textFontFamily: PropTypes.string,
  isSidetabOnInit: PropTypes.bool,
  sidetabParameters: PropTypes.shape({})
};

const Root = styled(ButtonBase)`
  position: fixed;
  left: ${props => props.align === 'left' && `${props.sideAlignSize}px`};
  right: ${props => props.align === 'right' && `${props.sideAlignSize}px`};
  z-index: 100000;
  display: inline-block;
  padding: ${props => props.padding};
  font-family: ${props => props.fontFamily};
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  color: ${props => props.color};
  background: ${props => props.background};
  border-radius: 10px 10px 0 0;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.3);
  box-sizing: border-box;

  &:focus {
    outline: none !important;
  }

  &:hover {
    color: ${props => props.color};
    background: ${props => props.background};
  }

  * {
    box-sizing: border-box;
  }

  ${({ isSidetabOnInit, sidetabParameters, isMobile }) => {
    if (isSidetabOnInit && !isEmpty(sidetabParameters)) {
      if (isMobile && sidetabParameters.mobileAlignBottom.enabled) {
        return css`
          left: ${props => props.align === 'left' && 0};
          right: ${props => props.align === 'right' && 0};
          bottom: 0;
          width: ${sidetabParameters.mobileAlignBottom.width || '50%'};
          padding: ${sidetabParameters.mobileAlignBottom.padding};
          border-radius: ${sidetabParameters.mobileAlignBottom.borderRadius};
          box-shadow: none;
        `;
      }
      if (
        !isMobile &&
        sidetabParameters.desktopAlignBottom &&
        sidetabParameters.desktopAlignBottom.enabled
      ) {
        return css`
          left: ${props => props.align === 'left' && 0};
          right: ${props => props.align === 'right' && 0};
          bottom: 0;
          width: ${sidetabParameters.desktopAlignBottom.width || 'auto'};
          padding: ${sidetabParameters.desktopAlignBottom.padding};
          border-radius: ${sidetabParameters.desktopAlignBottom.borderRadius};
          box-shadow: none;
        `;
      }
      return css`
        top: ${props => props.sidetabParameters.verticalOffset}px;
        transform: translate(50%, 0%) rotate(${props => (props.align === 'right' ? 270 : -270)}deg);
      `;
    }

    return css`
      top: 50%;
      transform: translate(${props => (props.align === 'right' ? 50 : -50)}%, -50%)
        rotate(${props => (props.align === 'right' ? 270 : -270)}deg);
    `;
  }}
`;
